import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ToasterService } from '../visual/toaster.service';

const existsFieldErrors = (errors: any): boolean => !!errors && !!errors.fields;
const existsGlobalError = (errors: any): boolean => !!errors && !!errors.global;

const removeFieldErrors = (form: FormGroup): void => {
  const controls = form.controls;
  Object.keys(controls).forEach(
    (key: string) => {
      const control = controls[key];
      if (control instanceof FormGroup) {
        removeFieldErrors(control);
      } else {
        control.setErrors(null);
      }
    }
  );
};

@Injectable()
export class ValidationService {

  constructor(
    private toasterService: ToasterService,
    private translateService: TranslateService
  ) { }

  showGlobalError(errors: any, prefix = 'error') {
    if (existsGlobalError(errors)) {
      const errorMessage = `${prefix}.${errors.global.code.toLowerCase()}`;
      this.toasterService.showErrorTranslating(errorMessage);
    } else if (!existsFieldErrors(errors)) {
      this.showUnrecognizedError(prefix);
    }
  }

  showFieldErrors(errors: any, form: FormGroup, formMapping: any, prefix = 'error') {
    if (!form) {
      return;
    }
    removeFieldErrors(form);
    if (errors && !this.assignErrorsToFields(errors, form, formMapping, prefix)) {
      this.showUnrecognizedError(prefix);
    }
  }

  private assignErrorsToFields(errors: any, form: FormGroup, formMapping: any, prefix: string): boolean {
    let existAllFields = true;
    Object.keys(errors).forEach(
      (key: string) => {
        if (formMapping.hasOwnProperty(key)) {
          const formField = form.get(formMapping[key]);
          this.assignErrorToField(formField, errors[key], prefix);
        } else {
          existAllFields = false;
        }
      }
    );

    return existAllFields;
  }

  private assignErrorToField(field: AbstractControl, error: any, prefix: string) {
    const errorKey = `${prefix}.${error.code.toLowerCase()}`;
    this.translateService.get(errorKey)
      .subscribe(
        (translation: string) => field.setErrors({ custom: translation })
      );
  }

  private showUnrecognizedError = (prefix: string) => {
    const unrecognizedError = `${prefix}.unrecognized_error`;
    this.toasterService.showErrorTranslating(unrecognizedError);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/validation/validation.service.ts